export const TEXT = {
  TITLE: {id: 'raf.postorder.title'},
  SUBTITLE: {id: 'raf.postorder.body'},
  COPY_CTA: {id: 'raf.referrals.copy_cta'},
  SHARE_CTA: {id: 'raf.referrals.share_cta'},
} as const;

export const ID = {
  BANNER: 'share-modal-banner',
};
